/**
 * Campos de la ruleta editables por usuarios NO-SUPERADMIN.
 * Debe mantenerse sincronizado con el backend:
 *   api/Roulette/domain/whitelist.ts
 */
export const ROULETTE_EDITABLE_FIELDS = [
  'name',
  'logo',
  'color',
  'imgBackground',
  'language',
  'roundDuration',
  'rollback',
  'active',
  'urlTransmision',
  'minutesToDisable',
  'manualDisable',
  'isManualRoulette',
  'openingTime',
  'closingTime',
  'alwaysOpen',
  'saveRecordings',
];

/**
 * Campos de la ruleta fisica editables por usuarios NO-SUPERADMIN.
 * Debe mantenerse sincronizado con el backend.
 */
export const ROULETTE_FISIC_EDITABLE_FIELDS = [
  'timeOne',
  'timeTwo',
  'timeThree',
  'timeFour',
  'aditionalTime',
  'timeToReleaseJack',
  'timeToStartAnimation',
  'animation',
  'minutesToDisable',
  'urlTransmision',
  'name',
  'providerId',
];

/**
 * Devuelve una copia del objeto dejando solo los campos editables cuando el
 * caller no es SUPERADMIN. Para SUPERADMIN devuelve el objeto intacto.
 *
 * @param {Object} payload
 * @param {string[]} whitelist
 * @param {boolean} isSuperAdmin
 */
export const pickEditableFields = (payload, whitelist, isSuperAdmin) => {
  if (isSuperAdmin) return { ...payload };

  return Object.keys(payload || {}).reduce((acc, key) => {
    if (whitelist.includes(key)) acc[key] = payload[key];
    return acc;
  }, {});
};
